import React from 'react';
import ServiceDetailPage from './Common/ServiceDetailPage';

const ServiceWebAppDevelopment = () => {
  return (
    <ServiceDetailPage
      title="Web App Development"
      heading="Custom web applications for growing startups and modern businesses"
      intro="App Core Innovation builds responsive, scalable web applications that help businesses launch products, improve operations, and create better digital experiences. We focus on practical solutions that are easy to use and strong enough to grow with your ambitions."
      imageSrc="/assets/images/banner/illustration-depicting-smiling-programmer-working-his-desk-using-computer-with-charts-data-screen_520881-8698.avif"
      imageAlt="Web app development illustration"
      features={[
        'Business websites, dashboards, and internal tools',
        'Modern front-end development with React, Next.js, and Angular',
        'Secure and scalable API integrations',
        'Responsive design that works beautifully across devices'
      ]}
      deliverables={[
        'UI/UX structure and page flow',
        'Frontend and backend implementation',
        'Deployment support and performance tuning',
        'Ongoing maintenance guidance and feature expansion'
      ]}
      outcomes={[
        'A polished digital product that feels trustworthy from day one',
        'Faster workflows for teams and customers',
        'A reliable platform that supports business growth'
      ]}
      stats={[
        { label: 'Delivery focus', value: 'Full-stack' },
        { label: 'Best fit', value: 'Startups' },
        { label: 'Approach', value: 'Lean & scalable' }
      ]}
      sideTitle="Why this service matters"
      sideText="A strong web app is often the first long-term digital asset a business builds. We make sure it feels clear, useful, and ready for future growth."
    />
  );
};

export default ServiceWebAppDevelopment;
